import { gql } from '@apollo/client';

import { Quote } from '../../types';

export type QuoteFields = Pick<
  Quote,
  | 'uuid'
  | 'state'
  | 'read_timestamp'
  | 'published'
  | 'created'
  | 'is_excl_vat_price'
  | 'isShortlisted'
  | 'supplier_id'
  | 'introMessage'
  | 'quotePriceDetails'
  | 'vatStatus'
> & {
  suppliers: {
    primaryTag: string | null;
  };
};

export interface CustomerQuotes {
  customerQuotes: {
    preFilteredQuotesCount: number;
    quotes: QuoteFields[];
  };
}

export const CUSTOMER_QUOTES = gql`
  query CustomerQuotes(
    $eventRequestId: String!
    $supplierTags: [String]
    $minPrice: Int = 0
    $maxPrice: Int
    $quoteState: CustomerQuoteState
    $orderBy: [CustomerQuotesOrderByInput!]
  ) {
    customerQuotes(
      eventRequestId: $eventRequestId
      filter: {
        supplierTags: $supplierTags
        priceRange: { minPrice: $minPrice, maxPrice: $maxPrice }
        quoteState: $quoteState
      }
      orderBy: $orderBy
    ) {
      preFilteredQuotesCount
      quotes {
        suppliers {
          primaryTag
        }
        uuid
        state
        read_timestamp
        created
        published
        is_excl_vat_price
        isShortlisted
        supplier_id
        quotePriceDetails {
          quoteUuid
          supplierTakeHomeAmount
          commissionFeeRate
          commissionFeeAmount
          quoteTotalAmount
          serviceFeeRate
          serviceFeeAmount
          protectPlusRate
          protectPlusAmount
          partnerCommissionRate
          partnerCommissionAmount
          affiliateCommissionRate
          affiliateCommissionAmount
          vatAmount
          customerTotalAmount
          quoteTotalExclVatAmount
          customerTotalPriceExclVat
          combinedServiceFeeRate
          combinedServiceFeeAmount
        }
        vatStatus
      }
    }
  }
`;
